<template>
  <div>
    <div class="row mb-2">{{ body }}</div>
    <div class="row">
      <div class="col-12">
        <CDataTable
          class="mb-0 table-outline"
          :items="orders"
          :fields="tableFields"
          head-color="light"
          hover
          no-sorting
          >
          <td slot="orderdate" slot-scope="{item}">
            {{ item.order_date }}
          </td>
          <td slot="quantity" slot-scope="{item}">
            {{ item.quantity }}
          </td>
          <td slot="amount" slot-scope="{item}">
            ${{ item.total | toCurrency }}
          </td>
        </CDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

Vue.filter('toCurrency', function (value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});
export default {
    name: "TableOrder",
    props: {
      table_labels: {
        type: Object,
        default() {
          return {
            order: '',
            amount: '',
            quantity: ''
          }
        }
      },
      body: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            orders: [],
            tableFields: [
              { key: 'orderdate', label: this.table_labels.order },
              { key: 'quantity', label: this.table_labels.quantity },
              { key: 'amount', label: this.table_labels.amount }
            ],
        }
    },
    methods: {
        initTable(orders) {
          this.orders.push(orders);
        }
    }
}
</script>